import React, { type ReactNode } from 'react';
import cn from 'classnames';
import { Paragraph as P } from '../Paragraph';
import * as styles from './styles.module.css';
import { SizeContextProvider } from '../Hooks/useSizeContext';

type ControlLabelArgs = {
  label?: string | ReactNode;
  description?: string | ReactNode;
  name?: string;
  disabled?: boolean;
  size?: 'medium' | 'large';
  alignment?: 'top' | 'center';
  className?: string;
  style?: React.CSSProperties;
};

export type ControlLabelProps = React.PropsWithChildren<ControlLabelArgs>;

export function ControlLabel({
  label,
  description,
  name,
  children,
  disabled,
  size = 'large',
  alignment = 'center',
  className = '',
  style = {},
}: ControlLabelProps) {
  return (
    <SizeContextProvider value={size}>
      <label
        className={cn([styles.controlLabel, disabled && styles.disabled, className])}
        style={style}
        htmlFor={name}
      >
        {label && (
          <div className={cn([styles.label, styles[size], styles[alignment]])}>
            <div className={styles.controlContainer}>{children}</div>
            {label}
          </div>
        )}
        {description && (
          <P size="small" color="secondary" className={styles.description}>
            {description}
          </P>
        )}
      </label>
    </SizeContextProvider>
  );
}
